export default "__VITE_ASSET__e589d164__"